import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from "../../../environments/environment";
import {SharedService} from '../shared-service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-external-content-viewer',
  templateUrl: './external-content-viewer.component.html',
  styleUrls: ['./external-content-viewer.component.scss']
})

export class ExternalContentViewerComponent implements OnInit, AfterViewInit {
  dataToDisplay: any;
  private contentPlaceholder: ElementRef;
  contentType: string;

  @ViewChild('fileViewer') set fileViewer(fileViewer: ElementRef) {
    this.contentPlaceholder = fileViewer;
  }

  constructor(public dialogRef: MatDialogRef<ExternalContentViewerComponent>, private spinner: NgxSpinnerService, private changeDetectorRef: ChangeDetectorRef,
              private sanitizer: DomSanitizer, private sharedService: SharedService, private toaster: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data?: any) {
    console.log(data)
    this.contentType = data.mimeType ? data.mimeType.split('/')[0] : undefined;
  }

  ngOnInit() {
    this.getFileContent();
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }


  getFileContent() {
    this.spinner.show();
    const params = {
      Key: this.data.filePath,
      type: this.data.mimeType
    };

    this.sharedService.getObjectsFromS3Bucket(params).subscribe(async (data: any) => {
      const blobUrl = await fetch(data).then(res => res.blob());
      this.dataToDisplay = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blobUrl));
      setTimeout(() => {
        if (this.contentType !== 'image' && !this.contentPlaceholder || (this.contentPlaceholder && this.contentPlaceholder.nativeElement && this.contentPlaceholder.nativeElement.contentDocument.body.innerHTML === '')) {
          this.dialogRef.close();
        }
        this.spinner.hide();
      }, 1000);
    }, () => {
      this.toaster.error("Unable to load the file in the viewer, Please try again.")
      this.spinner.hide();
      this.dialogRef.close();
    })
  }

  onDialogClose() {
    this.dialogRef.close();
  }

}
